import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const DatavizHeaderContainer = styled(FlexContainer)`
  gap: 16px;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  padding: 0 30px;
  flex-direction: column;
`

export const TopRow = styled(FlexContainer)({
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "10px",
})

export const TopRowLeft = styled(FlexContainer)({
  alignItems: "center",
  gap: "10px",
})

export const TopRowRight = styled(FlexContainer)({
  alignItems: "center",
  gap: "10px",
})

export const BottomRow = styled(FlexContainer)({
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "10px",
  flexWrap: "wrap",
})

export const BottomLeft = styled(FlexContainer)({
  alignItems: "center",
  gap: "10px",
})

export const BottomCenter = styled(FlexContainer)({
  alignItems: "center",
  gap: "10px",
})

export const BottomRight = styled(FlexContainer)({
  alignItems: "center",
  gap: "10px",
})
